import type { FC } from 'react'

import { cn } from '@/lib/utils'

type PageHeroProps = {
    roman: string
    italic?: string
    summary: string
    stacked?: boolean
    id?: string
}

/**
 * The oversized display lockup every inner page opens with: a roman word beside
 * or above an italic one, with the summary line set low and to the right.
 */
export const PageHero: FC<PageHeroProps> = ({ roman, italic, summary, stacked = false, id = 'page-hero' }) => {
    return (
        <section aria-labelledby={id} className='flex w-full flex-col justify-between gap-16 px-5 pt-28 pb-16 md:px-6 md:pt-32 md:pb-20'>
            <h1
                id={id}
                className={cn(
                    'display flex text-[16vw] md:text-[11vw]',
                    stacked ? 'flex-col items-start' : 'flex-row flex-wrap items-baseline gap-x-[0.22em]'
                )}
            >
                <span data-enter='0' data-enter-from='34' className='block opacity-0'>
                    {roman}
                </span>

                {italic && (
                    <span data-enter='0.12' data-enter-from='34' className='display-italic block opacity-0'>
                        {italic}
                    </span>
                )}
            </h1>

            <p
                data-enter='0.35'
                className='serif-body ml-auto max-w-[320px] text-[1.15rem] opacity-0 md:max-w-[300px] md:text-[1.3rem]'
            >
                {summary}
            </p>
        </section>
    )
}
